import { useTranslation } from 'react-i18next';

import { LoadingIndicator } from '@/shared/components/loading-indicator';
import { Card, CardContent } from '@/shared/components/ui/card';

export const UpdatePasswordInProgress = () => {
  const { t } = useTranslation('auth');

  return (
    <Card variant="form">
      <CardContent className="flex flex-col items-center justify-center gap-8 pb-16 pt-14">
        <LoadingIndicator className="size-[50px]" />
        <p className="text-3xl font-bold">
          {t('UpdatePasswordInProgress.title')}
        </p>
      </CardContent>
    </Card>
  );
};
